export function createAccountSearchStore() {
    return {
        namespaced: true,

        state: {
            /**
             * The query used for the last search that was performed.
             * this.results should also be populated in this case.
             *
             * @type {string}
             */
            query: '',

            /**
             * The results of the last search that was performed.
             * Null if no search has been performed since the results were last cleared.
             *
             * @type {CustomerAccount[]|null}
             */
            results: null,

            currentPage: 1,

            pageSize: 10,
        },

        mutations: {
            clear(state) {
                state.query = '';
                state.results = null;
                state.currentPage = 1;
            },

            /**
             * @param {{}} state
             * @param {{query: string, results: CustomerAccount[]}|null} data
             */
            setResults(state, data) {
                const { query, results } = data || {};
                state.query = query || '';
                state.results = results || null;
            },

            setCurrentPage(state, page) {
                state.currentPage = page;
            },
        },
    };
}
